import LoginForm from './validations/login-form';
import RegistrationForm from './validations/registration-form';
import ForgotPasswordForm from './validations/forgot-password-form';
import ResetPasswordForm from './validations/reset-password-form';
import CampaignOfferSendForm from './validations/campaign-offer-send-form';
import PromotionNewsletterForm from './validations/promotion-newsletter-form';

/**
 * Modal validation handler module.
 *
 * @author Kovács Tamás
 * @description This module dynamically import the modal form validations.
 * @param {string} validation - The given validation name, same as the form id.
 */
function ModalValidationHandler(
    validation,
    openModal,
) {
    const validations = {
        loginForm: LoginForm(),
        registrationForm: RegistrationForm(),
        forgotPasswordForm: ForgotPasswordForm(),
        resetPasswordForm: ResetPasswordForm(),
        campaignOfferSendForm: CampaignOfferSendForm(),
        promotionNewsletterForm: PromotionNewsletterForm(),
    };

    validations[validation].init(
        openModal,
    );
}

export default ModalValidationHandler;
